export default {"src":"/_next/static/media/card-general.e93692dc.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};